module.exports = __webpack_public_path__ + "assets/img/system-icon1.6a45c276.png";